export default "__VITE_ASSET__MBR3JJN7__"